import axios from 'axios';

import {
  ROOT,
  HISTORY_URL,
  HISTORY_ALERTS_URL,
  SENT_NOTIFICATIONS_URL,
  HISTORY_PAUSES_URL,
  HISTORY_LOW_BATTERY_URL,
  EXPORT_LOGS_URL,
  EXPORT_ALARMS_URL,
  SET_HISTORY,
  SET_HISTORY_COUNT,
  SET_HISTORY_RECORDS,
  SET_HISTORY_RECORDS_COUNT,
  SET_NOTIFICATIONS_RECORDS,
  SET_NOTIFICATIONS_RECORDS_COUNT
} from '../../constants';

export const getHistory = (page = 1, pageSize = 10, startDate = '', endDate = '', patient = '', monitor = '', ids = '', requestScreen = '' ) => {
  const query = {};
  if (page !== -1 && pageSize !== -1) {
    query.page = page;
    query.page_size = pageSize;
  }
  let requestUrl = HISTORY_URL;
  if (requestScreen === 'pauses') requestUrl = HISTORY_PAUSES_URL;
  if (requestScreen === 'low_battery') requestUrl = HISTORY_LOW_BATTERY_URL;
  if (ids.length) query.ids = ids;
  if (startDate.length) query.link_date = startDate;
  if (endDate.length) query.unlink_date = endDate;
  if (patient.length) query.patient = patient;
  if (monitor.length) query.mac_address = monitor;
  return async (dispatch) => {
    axios
      .get(`${ROOT}${requestUrl}`, { params: query })
      .then((response) => {
        dispatch(setHistory(response.data.results));
        dispatch(setHistoryCount(response.data.count));
      })
      .catch((error) => {
        const { response } = error;
        const { data } = response;
        return { success: false, data };
      });
    dispatch(setHistory([]));
    dispatch(setHistoryCount(0));
  };
};

export const getHistoryRecords = (patient,ids, page = 1, pageSize = 10, startDate = '', endDate = '', monitor = '') => {
  const body = { patient: parseInt(patient, 10), ids: ids};
  const query = {};
  
  if (page !== -1 && pageSize !== -1) {
    query.page = page;
    query.page_size = pageSize;
  }
  if (startDate.length) body.start_date = startDate;
  if (endDate.length) body.end_date = endDate;
  if (monitor.length) body.monitor = monitor;

  return async (dispatch) => {
    axios
      .post(`${ROOT}${HISTORY_ALERTS_URL}`, body, { params: query })
      .then((response) => {
        dispatch(setHistoryRecords(response.data.results));
        dispatch(setHistoryRecordsCount(response.data.count));
      })
      .catch((error) => {
        const { response } = error;
        const { data } = response;
        return { success: false, data };
      });
    dispatch(setHistoryRecords([]));
    dispatch(setHistoryRecordsCount(0));
  };
};

export const getNotificationSentLog = (user, page = 1, pageSize = 10, startDate = '', endDate = '') => {
  const query = { user: parseInt(user, 10) };;
  
  if (page !== -1 && pageSize !== -1) {
    query.page = page;
    query.page_size = pageSize;
  }
  if (startDate.length) query.created_at__gte = new Date(startDate).toISOString();
  if (endDate.length) query.created_at__lte = new Date(endDate).toISOString();

  return async (dispatch) => {
    axios
      .get(`${ROOT}${SENT_NOTIFICATIONS_URL}`, { params: query })
      .then((response) => {
        dispatch(setNotificationRecords(response.data.results || []));
        dispatch(setNotificationRecordsCount(response.data.count || 0));
      })
      .catch((error) => {
        const { response } = error;
        const { data } = response || {};
        return { success: false, data };
      });
  };
};


export const getPatientHistoryExport = (id, ids, startDate = '', endDate = '', patient, monitor = '') => {
  const body = { patient: parseInt(id, 10) };
  if (ids.length) body.ids = ids;
  if (startDate.length) body.start_date = startDate;
  if (endDate.length) body.end_date = endDate;
  if (monitor.length) body.monitor = monitor;
  return axios.post(`${ROOT}${EXPORT_ALARMS_URL}`, body).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    let fileName = 'alert_history';
    if (patient) fileName += `_${patient.first_name}_${patient.last_name}`;
    if (monitor.length) fileName += `_${monitor}`;
    if (startDate.length) fileName += `_from_${startDate}`;
    if (endDate.length) fileName += `_until_${endDate}`;
    link.setAttribute('download', `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  });
};

export const getHistoryExport = (patient = '', startDate = '', endDate = '', monitor = '') => {
  const body = {};
  if (startDate.length) body.link_date = startDate;
  if (endDate.length) body.unlink_date = endDate;
  if (patient.length) body.patient = patient;
  if (monitor.length) body.mac_address = monitor;
  return axios.post(`${ROOT}${EXPORT_LOGS_URL}`, body).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    let fileName = 'monitor_history';
    if (patient.length) fileName += `_${patient}`;
    if (monitor.length) fileName += `_${monitor}`;
    if (startDate.length) fileName += `_from_${startDate}`;
    if (endDate.length) fileName += `_until_${endDate}`;
    link.setAttribute('download', `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  });
};

export const setHistory = (history) => {
  return {
    type: SET_HISTORY,
    history,
  };
};

export const setHistoryCount = (count) => {
  return {
    type: SET_HISTORY_COUNT,
    count,
  };
};

export const setHistoryRecords = (records) => {
  return {
    type: SET_HISTORY_RECORDS,
    records,
  };
};

export const setHistoryRecordsCount = (count) => {
  return {
    type: SET_HISTORY_RECORDS_COUNT,
    count,
  };
};

export const setNotificationRecords = (records) => {
  return {
    type: SET_NOTIFICATIONS_RECORDS,
    records,
  };
};

export const setNotificationRecordsCount = (count) => {
  return {
    type: SET_NOTIFICATIONS_RECORDS_COUNT,
    count,
  };
};

